// src/components/SitzungQuickCreateModal.jsx
// Kompaktes Modal zum direkten Anlegen einer Sitzung aus dem Pendenzen-Formular
// heraus (US-SITZ-001: "bestehende Sitzung waehlen oder neue Sitzung direkt
// anlegen"). Anwesende werden hier bewusst nicht erfasst (dafür der volle
// Sitzungen-Tab) – hier zählt schnelle Zuordnung beim Jour fix.
import React, { useState } from "react";
import { createSitzung, suggestNextNr, SITZUNG_ARTEN } from "../services/azureSitzungenService";
import { useAuth } from "../hooks/useAuth";

const SitzungQuickCreateModal = ({ projectUuid, sitzungen, onClose, onCreated }) => {
  const { user } = useAuth();
  const [art, setArt] = useState(SITZUNG_ARTEN[0]);
  const [nr, setNr] = useState(suggestNextNr(sitzungen, SITZUNG_ARTEN[0]));
  const [datum, setDatum] = useState(new Date().toISOString().slice(0, 10));
  const [ort, setOrt] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleArtChange = (value) => {
    setArt(value);
    setNr(suggestNextNr(sitzungen, value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      setError(null);
      const created = await createSitzung(
        projectUuid,
        { art, nr, datum, ort, anwesende: [] },
        user?.email || user?.userDetails || ""
      );
      onCreated(created);
    } catch (err) {
      setError(err.message || "Die Sitzung konnte nicht gespeichert werden.");
    } finally {
      setSaving(false);
    }
  };

  // Weder Klick auf den Hintergrund noch Escape schliessen (Nutzerwunsch, ADR
  // 0060): kein versehentliches Verwerfen ungespeicherter Eingaben.
  return (
    <div
      className="pendenzen__modal-overlay"
      onKeyDown={(e) => {
        if (e.key === "Escape") e.stopPropagation();
      }}
    >
      <div className="pendenzen__modal" onClick={(e) => e.stopPropagation()}>
        <form onSubmit={handleSubmit}>
          <div className="pendenzen__modal-header">
            <h3>Neue Sitzung</h3>
            <button type="button" className="pendenzen__modal-close" onClick={onClose} aria-label="Schliessen">
              ×
            </button>
          </div>
          <div className="pendenzen__modal-body">
            {error && (
              <div className="pendenzen__error" role="alert">
                {error}
              </div>
            )}
            <div className="pendenzen__form-grid">
              <label className="pendenzen__field">
                <span>Art</span>
                <input
                  type="text"
                  list="sitzungsarten-quick"
                  value={art}
                  onChange={(e) => handleArtChange(e.target.value)}
                />
                <datalist id="sitzungsarten-quick">
                  {SITZUNG_ARTEN.map((a) => (
                    <option key={a} value={a} />
                  ))}
                </datalist>
              </label>
              <label className="pendenzen__field">
                <span>Nummer</span>
                <input type="text" value={nr} onChange={(e) => setNr(e.target.value)} />
              </label>
              <label className="pendenzen__field">
                <span>Datum</span>
                <input type="date" value={datum} onChange={(e) => setDatum(e.target.value)} />
              </label>
              <label className="pendenzen__field">
                <span>Ort</span>
                <input
                  type="text"
                  value={ort}
                  onChange={(e) => setOrt(e.target.value)}
                  placeholder="optional"
                />
              </label>
            </div>
          </div>
          <div className="pendenzen__modal-footer">
            <div className="pendenzen__modal-footer-right">
              <button type="button" className="pendenzen__btn" onClick={onClose} disabled={saving}>
                Abbrechen
              </button>
              <button type="submit" className="pendenzen__btn pendenzen__btn--primary" disabled={saving}>
                {saving ? "Speichern..." : "Speichern"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SitzungQuickCreateModal;
